module.exports = __webpack_public_path__ + "static/media/i5.6555340e.svg";